module.exports = "/images/vendor/flag-icon-css/flags/4x3/vi.svg?4952d5bf33f73b27ccfe260531eb66f3";